/******************************************************************************
 * GENERATED by scripts/generateHooks.ts — DO NOT EDIT.
 * Re-run with `pnpm zen3:generate`.
 ******************************************************************************/

/* eslint-disable */

import { useModelQueries, type ModelQueryHooks } from '@zenstackhq/tanstack-query/react';
import { schema } from '../zen3/schema-lite';

type Hooks = ModelQueryHooks<typeof schema, 'SettingTemplate'>;
const hooks = useModelQueries(schema, 'SettingTemplate');

export const useAggregateSettingTemplate: Hooks['useAggregate'] = hooks.useAggregate;
export const useCountSettingTemplate: Hooks['useCount'] = hooks.useCount;
export const useCreateSettingTemplate: Hooks['useCreate'] = hooks.useCreate;
export const useCreateManySettingTemplate: Hooks['useCreateMany'] = hooks.useCreateMany;
export const useCreateManyAndReturnSettingTemplate: Hooks['useCreateManyAndReturn'] = hooks.useCreateManyAndReturn;
export const useDeleteSettingTemplate: Hooks['useDelete'] = hooks.useDelete;
export const useDeleteManySettingTemplate: Hooks['useDeleteMany'] = hooks.useDeleteMany;
export const useExistsSettingTemplate: Hooks['useExists'] = hooks.useExists;
export const useFindFirstSettingTemplate: Hooks['useFindFirst'] = hooks.useFindFirst;
export const useFindManySettingTemplate: Hooks['useFindMany'] = hooks.useFindMany;
export const useFindUniqueSettingTemplate: Hooks['useFindUnique'] = hooks.useFindUnique;
export const useGroupBySettingTemplate: Hooks['useGroupBy'] = hooks.useGroupBy;
export const useInfiniteFindManySettingTemplate: Hooks['useInfiniteFindMany'] = hooks.useInfiniteFindMany;
export const useSuspenseAggregateSettingTemplate: Hooks['useSuspenseAggregate'] = hooks.useSuspenseAggregate;
export const useSuspenseCountSettingTemplate: Hooks['useSuspenseCount'] = hooks.useSuspenseCount;
export const useSuspenseFindFirstSettingTemplate: Hooks['useSuspenseFindFirst'] = hooks.useSuspenseFindFirst;
export const useSuspenseFindManySettingTemplate: Hooks['useSuspenseFindMany'] = hooks.useSuspenseFindMany;
export const useSuspenseFindUniqueSettingTemplate: Hooks['useSuspenseFindUnique'] = hooks.useSuspenseFindUnique;
export const useSuspenseGroupBySettingTemplate: Hooks['useSuspenseGroupBy'] = hooks.useSuspenseGroupBy;
export const useSuspenseInfiniteFindManySettingTemplate: Hooks['useSuspenseInfiniteFindMany'] = hooks.useSuspenseInfiniteFindMany;
export const useUpdateSettingTemplate: Hooks['useUpdate'] = hooks.useUpdate;
export const useUpdateManySettingTemplate: Hooks['useUpdateMany'] = hooks.useUpdateMany;
export const useUpdateManyAndReturnSettingTemplate: Hooks['useUpdateManyAndReturn'] = hooks.useUpdateManyAndReturn;
export const useUpsertSettingTemplate: Hooks['useUpsert'] = hooks.useUpsert;
